import Divider from '@mui/material/Divider';

function VerticalDivider() {
  const verticalDividerStyle = {
    borderLeft: '2px solid rgba(255,255,255,0.1', 
    height: '100%',
  };

  return (
    <Divider orientation="vertical" style={verticalDividerStyle} />
  );
}

export default VerticalDivider;
